const MLBF_EMAIL = 'kontakt@mlbf-barrierefrei.de';
const MLBF_URL = 'https://www.mlbf-barrierefrei.de/';
const FEEDBACK_EMAIL = 'akquise-marketing@zv.fraunhofer.de';
const INFO_EMAIL = 'info@zv.fraunhofer.de';

export const accessibilityStatementContent = {
  de: {
    title: 'Informationen zur Barrierefreiheit nach § 14 BFSG und Anlage 3 BFSG',
    subtitle: 'für das Teilnehmerbuchungsportal Veranstaltungen MEA',
    sections: [
      {
        heading: 'Geltungsbereich und Beschreibung der Dienstleistung',
        content: [
          {
            type: 'paragraph',
            text: 'Die Fraunhofer-Gesellschaft ist bemüht, das digitale Teilnehmerbuchungsportal Veranstaltungen MEA im Einklang mit den Anforderungen des Barrierefreiheitsstärkungsgesetzes (BFSG) und der Verordnung zum Barrierefreiheitsstärkungsgesetz (BFSGV) barrierefrei zugänglich zu machen.'
          },
          {
            type: 'paragraph',
            text: 'Diese Erklärung gilt für das Teilnehmerbuchungsportal Veranstaltungen MEA. Über MEA können Teilnehmende insbesondere veranstaltungsbezogene Informationen aufrufen und Anmeldungen digital durchführen:'
          },
          {
            type: 'list',
            items: [
              'Veranstaltungsinformationen lesen',
              'Anmeldeformular ausfüllen',
              'Angaben prüfen und absenden'
            ]
          }
        ]
      },
      {
        heading: 'Stand der Vereinbarkeit mit den Anforderungen',
        content: [
          {
            type: 'paragraph',
            text: 'MEA ist aufgrund der nachfolgend beschriebenen Einschränkungen weitestgehend mit den geltenden Barrierefreiheitsanforderungen vereinbar.'
          },
          {
            type: 'paragraph',
            text: 'Die Einschätzung beruht auf einer Selbstbewertung, automatisierten technischen Prüfungen und einer ergänzenden fachlichen Bewertung der festgestellten Befunde. Automatisierte Prüfergebnisse dienen dabei als Hinweis auf den technischen Stand, ersetzen jedoch keine vollständige Konformitätsprüfung.'
          }
        ]
      },
      {
        heading: 'Nicht barrierefreie Inhalte',
        content: [
          {
            type: 'paragraph',
            text: 'MEA ist derzeit noch nicht in allen Bereichen vollständig barrierefrei. Einschränkungen können insbesondere bei der Darstellung und Wahrnehmbarkeit von Inhalten, etwa aufgrund nicht durchgängig ausreichender Kontraste, bei der Bedienung einzelner Funktionen sowie bei der Nutzung mit assistiven Technologien auftreten.'
          },
          {
            type: 'paragraph',
            text: 'Die bekannten Einschränkungen werden regelmäßig überprüft und bei der Weiterentwicklung von MEA berücksichtigt.'
          }
        ]
      },
      {
        heading: 'Unterstützende Nutzungsmöglichkeiten',
        content: [
          {
            type: 'paragraph',
            text: 'Nutzende können die Zoom-, Vergrößerungs- und Kontrastfunktionen ihres Browsers oder Betriebssystems verwenden. Diese Funktionen können die Nutzung erleichtern, beseitigen die beschriebenen Einschränkungen jedoch nicht in jedem Fall vollständig.'
          }
        ]
      },
      {
        heading: 'Erstellung und Überprüfung dieser Erklärung',
        content: [
          { type: 'paragraph', text: 'Diese Erklärung wurde am 12.10.2026 erstellt.' },
          { type: 'paragraph', text: 'Die Bewertung beruht auf:' },
          {
            type: 'list',
            items: [
              'einer Selbstbewertung,',
              'automatisierten technischen Prüfungen und',
              'einer fachlichen Bewertung der identifizierten Befunde.'
            ]
          }
        ]
      },
      {
        heading: 'Überwachungsbehörde',
        content: [
          {
            type: 'address',
            lines: [
              'Marktüberwachungsstelle der Länder für die Barrierefreiheit von Produkten und Dienstleistungen - Anstalt öffentlichen Rechts (MLBF AöR)',
              'Carl-Miller-Straße 6',
              '39112 Magdeburg',
              { label: 'Telefon', text: '+49 391 289 230 23', href: 'tel:+4939128923023' },
              { label: 'E-Mail', text: MLBF_EMAIL, href: `mailto:${MLBF_EMAIL}` },
              { label: 'Online', text: MLBF_URL, href: MLBF_URL, external: true }
            ]
          }
        ]
      },
      {
        heading: 'Feedback und Kontakt',
        content: [
          {
            type: 'paragraph',
            text: 'Sind Ihnen Barrieren bei der Nutzung von MEA aufgefallen? Dann teilen Sie uns diese bitte mit. Beschreiben Sie nach Möglichkeit, auf welcher Seite und bei welcher Funktion die Barriere auftritt. Wir prüfen Ihren Hinweis und informieren Sie über das weitere Vorgehen.'
          },
          {
            type: 'address',
            lines: [{ label: 'E-Mail', text: FEEDBACK_EMAIL, href: `mailto:${FEEDBACK_EMAIL}` }]
          },
          {
            type: 'address',
            lines: [
              'Fraunhofer-Gesellschaft',
              'zur Förderung der angewandten Forschung e.V.',
              'Hansastraße 27 c',
              '80686 München',
              { label: 'E-Mail', text: INFO_EMAIL, href: `mailto:${INFO_EMAIL}` },
              { label: 'Telefon', text: '+49 89 1205-0', href: 'tel:+498912050' },
              { label: 'Fax', text: '+49 89 1205-7531' }
            ]
          }
        ]
      }
    ]
  },
  en: {
    title: 'Accessibility Statement pursuant to Section 14 of the BFSG and Annex 3 to the BFSG',
    subtitle: 'for the MEA Events Participant Registration Portal',
    sections: [
      {
        heading: 'Scope and Description of the Service',
        content: [
          {
            type: 'paragraph',
            text: 'The Fraunhofer Society strives to ensure that the digital “MEA Events” participant registration portal is accessible in accordance with the requirements of the Act on Strengthening Accessibility (BFSG) and the Ordinance on the Act on Strengthening Accessibility (BFSGV).'
          },
          {
            type: 'paragraph',
            text: 'This statement applies to the “MEA Events” participant registration portal. Through MEA, participants can access event-related information and complete registrations digitally:'
          },
          {
            type: 'list',
            items: [
              'Read event information',
              'Fill out the registration form',
              'Review and submit their information'
            ]
          }
        ]
      },
      {
        heading: 'Status of Compliance with Requirements',
        content: [
          {
            type: 'paragraph',
            text: 'MEA is largely compliant with applicable accessibility requirements, subject to the limitations described below.'
          },
          {
            type: 'paragraph',
            text: 'This assessment is based on self-assessment, automated technical tests, and a supplementary expert evaluation of the findings. Automated test results serve as an indication of the technical status but do not replace a comprehensive compliance review.'
          }
        ]
      },
      {
        heading: 'Non-accessible content',
        content: [
          {
            type: 'paragraph',
            text: 'MEA is not yet fully accessible in all areas. Limitations may occur in the presentation and perceptibility of content—for example, due to insufficient contrast in some cases—as well as in the operation of individual functions and when using assistive technologies.'
          },
          {
            type: 'paragraph',
            text: 'Known limitations are reviewed regularly and taken into account in the further development of MEA.'
          }
        ]
      },
      {
        heading: 'Supportive Usage Options',
        content: [
          {
            type: 'paragraph',
            text: 'Users can utilize the zoom, magnification, and contrast features of their browser or operating system. These features can make usage easier but do not always fully eliminate the limitations described.'
          }
        ]
      },
      {
        heading: 'Creation and Review of This Statement',
        content: [
          { type: 'paragraph', text: 'This statement was created on October 12, 2026.' },
          { type: 'paragraph', text: 'The assessment is based on:' },
          {
            type: 'list',
            items: [
              'a self-assessment,',
              'automated technical tests, and',
              'a technical evaluation of the identified findings.'
            ]
          }
        ]
      },
      {
        heading: 'Supervisory Authority',
        content: [
          {
            type: 'address',
            lines: [
              'State Market Surveillance Agency for the Accessibility of Products and Services—Public-Law Institution (MLBF AöR)',
              'Carl-Miller-Straße 6',
              '39112 Magdeburg',
              { label: 'Phone', text: '+49 391 289 230 23', href: 'tel:+4939128923023' },
              { label: 'Email', text: MLBF_EMAIL, href: `mailto:${MLBF_EMAIL}` },
              { label: 'Online', text: MLBF_URL, href: MLBF_URL, external: true }
            ]
          }
        ]
      },
      {
        heading: 'Feedback and Contact',
        content: [
          {
            type: 'paragraph',
            text: 'Have you encountered any barriers while using MEA? If so, please let us know. If possible, describe on which page and with which feature the barrier occurred. We will review your report and inform you of the next steps.'
          },
          {
            type: 'address',
            lines: [{ label: 'Email', text: FEEDBACK_EMAIL, href: `mailto:${FEEDBACK_EMAIL}` }]
          },
          {
            type: 'address',
            lines: [
              'Fraunhofer Society',
              'for the Promotion of Applied Research e.V.',
              'Hansastraße 27 c',
              '80686 Munich',
              { label: 'Email', text: INFO_EMAIL, href: `mailto:${INFO_EMAIL}` },
              { label: 'Phone', text: '+49 89 1205-0', href: 'tel:+498912050' },
              { label: 'Fax', text: '+49 89 1205-7531' }
            ]
          }
        ]
      }
    ]
  }
};
